import temp from '../temp/config';
import { dataFetcher } from '../dataFetcher';
import { loading } from '../utils/obj-utils';

export const openCloudCar = (resourceId, callback) => {
  const query = `scene=${encodeURIComponent(`resource_id=${resourceId}&referer=web`)}`;
  const path = '/components/pages/scanVehicleCode/index';
  dataFetcher(`${temp?.h5?.url}?path=${encodeURIComponent(path)}&query=${encodeURIComponent(query)}&type=0`, null, false).then((response) => {
    const data = response?.data;
    if (data?.code === 10000) {
      const {
        info: { openlink }
      } = data;
      callback && callback(openlink);
      try {
        window.top.location.href = openlink;
      } catch (e) {
        location.href = openlink;
      }
    }
  });
};

export const openHome = (callback) => {
  const query = `r=${location.href}`;
  const path = '/components/pages/index/index';
  dataFetcher(`${temp?.h5?.url}?path=${encodeURIComponent(path)}&query=${encodeURIComponent(query)}&type=0`, null, false).then((response) => {
    const data = response?.data;
    if (data?.code === 10000) {
      const {
        info: { openlink }
      } = data;
      callback && callback(openlink);
      location.href = openlink;
    }
  });
};

export const GetGmallAppSchemeUrl = (path, callback, adcode, clkid) => {
  loading.set();

  const mallBase = 'https://mall.ghac.cn';
  const mallPaths = {
    index: mallBase,
    indexWithSlash: mallBase + '/',
    channel: mallBase + '/?channel=GW',
    activityDetail: mallBase + '/o2o/activity-detail/',
    opentionDetail: mallBase + '/o2o/opention-detail/'
  };
  const oldPath = path.split('?')[0];
  let newPath = 'pages/index';
  let srclink = '';
  let activityId = '';
  if (oldPath === mallPaths.index || oldPath === mallPaths.indexWithSlash || oldPath === mallPaths.channel) {
    newPath = 'pages/index';
    if (!activityId) {
      newPath = 'pages/index';
    }
  } else if (oldPath.startsWith(mallPaths.activityDetail)) {
    newPath = 'pageO2o/o2o/activity-detail/_activityId';
    activityId = oldPath.split(mallPaths.activityDetail)[1];
    if (!activityId) {
      newPath = 'pages/index';
    }
  } else if (oldPath.startsWith(mallPaths.opentionDetail)) {
    newPath = 'pages/web';
    srclink = path;
  }
  let apiPath = '';
  if (oldPath.startsWith(mallPaths.opentionDetail)) {
    apiPath = `/api/honda/v1/DWP/GetGmallAppSchemeUrlOptional?path=${newPath}&srclink=${srclink || ''}${adcode ? `&adcode=${adcode}` : ''}${
      clkid ? `&clkid=${clkid}` : ''
    }`;
  } else {
    apiPath = `/api/honda/v1/DWP/GetGmallAppSchemeUrl?path=${newPath}&activityId=${activityId || ''}${adcode ? `&adcode=${adcode}` : ''}${
      clkid ? `&clkid=${clkid}` : ''
    }&channel=GW`;
  }
  dataFetcher(apiPath, null)
    .then(({ data }) => {
      loading.delete();
      if (data.Status) {
        try {
          window.top.location.href = data.Data.data;
          callback?.(data.Data.data); // 使用可选链操作符简化回调函数的调用
        } catch (e) {
          location.href = data.Data.data;
          callback?.(data.Data.data);
        }
      }
    })
    .catch((error) => {
      console.log(error);
      loading.delete();
    });
};
export const GetFansAppSchemeUrl = (callback) => {
  dataFetcher('/api/honda/v1/DWP/GetFansAppSchemeUrl', null)
    .then(({ data }) => {
      if (data.Status) {
        try {
          // window.open(data.Data.data);
          callback && callback(data.Data.data);
          window.top.location.href = data.Data.data;
        } catch (e) {
          callback && callback(data.Data.data);
          location.href = data.Data.data;
        }
      } else {
      }
    })
    .catch((error) => {
      console.log(error);
    });
};
